import { Controller } from '@hotwired/stimulus'

// Reloads the page with the changed select's value in the query string, so
// the server can re-render the parts of a form that depend on that choice.
// Fields named in `keep` carry their submitted values across the reload. The
// change stops here, so nothing else on the page acts on a form being replaced.
export default class extends Controller {
  static values = { url: String, keep: Array }

  reload(event) {
    event.stopPropagation()
    const { name, value, form } = event.target
    const url = new URL(this.urlValue || window.location.href, window.location.href)
    url.searchParams.set(name, value)
    if (form) {
      const data = new FormData(form)
      this.keepValue.forEach(kept => {
        const submitted = data.getAll(kept).at(-1)
        if (submitted) url.searchParams.set(kept, submitted)
      })
    }
    if (window.Turbo) {
      window.Turbo.visit(url.toString())
    } else {
      window.location.assign(url.toString())
    }
  }
}
